<div class="fullscreen-loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
        <div class="spinner"></div>
        <p class="loading-message">{{ message }}</p>
        <p class="loading-hint">Please wait... Do not close or refresh this page</p>
    </div>
</div>
